import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { ReqCheckSystemAccount, ReqAddSystemAccount } from '../../../../item/ItemAccount';
import { api_addSystemAccount, api_checkSystemAccount } from '../../../../api/apiAccount';
import { SingleInput, SingleRedio } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ListSelect } from '../../Res/ListSelect';
import { api_getRoleList } from '../../../../api/apiCompany';


export function AccountAdd() {
  const [account, setAccount] = useState("")
  const [nickName, setNickName] = useState("")
  const [note, setNote] = useState("")
  const [isDisable, setIsDisable] = useState(false)
  const [accountRoles, setAccountRoles] = useState([])

  const [roles, setRoles] = useState([])

  useEffect(() => {
    getSystemRoleList()
  }, [])


  function toCancel() {
    window.history.back();
  }

  function getSystemRoleList() {
    api_getRoleList({
      departmentId: "admin",
      success: (result) => {
        //console.log(result)
        setRoles(result.list)
      },
      failure: (err) => {
        console.log(err)
      }
    })
  }

  function toCheck() {
    if (account !== "" && nickName !== "") {
      var mReqCheckSystemAccount = new ReqCheckSystemAccount({ mobile: account })
      api_checkSystemAccount({
        mReqCheckSystemAccount,
        success: (jsonData) => {
          if (jsonData.status) {
            toAdd()
          }
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: err,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '帳號, 暱稱 不得為空',
      })
    }
  }

  function toAdd() {
    if (account === "" || nickName === "") {
      Swal.fire({
        type: 'error',
        title: '帳號, 暱稱 不得為空',
      })
      return
    }

    if (accountRoles.length === 0) {
      Swal.fire({
        type: 'error',
        title: '請至少選擇一個角色',
      })
      return
    }

    var userInfo = Auth.getUserInfo()
    var mReqAddSystemAccount = new ReqAddSystemAccount({
      mobile: account,
      nickName,
      note,
      isDisable,
      creatAccountId: userInfo.accountId
    })
    api_addSystemAccount({
      mReqAddSystemAccount,
      accountRoles,
      success: (jsonData) => {
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: '新增成功',
        }).then(function () {
          setAccount("")
          setNickName("")
          setNote("")
          setIsDisable(false)
          window.history.go(-1)
          //window.history.replace("/ManagerList");
        })
      },
      failure: (err) => {
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err.message,
        })
      }
    })
  }

  const isDisableItems = [
    { "val": 0, "name": "是" },
    { "val": 1, "name": "否" },
  ]

  var title = "帳號資訊"
  var content =
    <>
      <div class="row">
        <div class="col-md-12">
          <SingleRedio title={"是否啟用"}
            arr={isDisableItems}
            val={isDisable ? 1 : 0}
            action={setIsDisable}
            size={4}
          />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"手機號碼-登入帳號"} val={account} action={setAccount} placeholder={"0988123456"} size={4} />
          <SingleInput title={"暱稱"} val={nickName} action={setNickName} placeholder={"鴨子"} size={4} />
          <SingleInput title={"註記"} val={note} action={setNote} placeholder={"XXXXX"} size={4} />
        </div>
      </div> <div class="hr-line-dashed"></div>
      <div class="row">
        <div class="col-md-12">
          <ListSelect
            title={"角色"}
            ids={accountRoles}
            list={roles}
            sId={"roleId"}
            sName={"roleName"}
            setIds={setAccountRoles}
          />
        </div>
      </div>
    </>

  var footer =
    <div class="row">
      <div class="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toCheck} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
  )
}